import { render, staticRenderFns } from "./GraphTournamentTriunfos.vue?vue&type=template&id=43c58043"
import script from "./GraphTournamentTriunfos.vue?vue&type=script&lang=js"
export * from "./GraphTournamentTriunfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports